import React from 'react'
import { Card, CardHeader, Button, CardTitle, CardSubtitle } from 'reactstrap'
import { Form, InputGroup } from 'react-bootstrap'

export default function ListTopBar({ 
	filterType, 
	setFilterType, 
	filterValue, 
	setFilterValue, 
	reload,
	title,
	subtitle,
	options,
	ctaText,
	handleCtaClick,
	secundaryCtaText,
	handleSecundaryCtaClick,
	tertiaryCtaText,
	handleTertiaryCtaClick,
	className,
	prefix,
	onExport
}) {
	return (
		<React.Fragment>
			<Card className={className}>
				<CardHeader>
					{ options && (
						<div className="float-right mt-2 mb-0">
							<InputGroup>
								{ prefix && (
									<InputGroup.Prepend>
										{prefix}
									</InputGroup.Prepend>
								)}
								<InputGroup.Prepend>
									<Form.Control 
										as="select" 
										className="bg-light"
										value={filterType}
										onChange={e => setFilterType(e.target.value)}
									>
										{options.map((option,i) => 
											<option key={i} value={option.value}>{option.label}</option>
										)}
									</Form.Control>
								</InputGroup.Prepend>
								<Form.Control 
									placeholder="Escriba aquí" 
									value={filterValue}
									onChange={e => setFilterValue(e.target.value)}
								/>
								<InputGroup.Append className="mb-1">
									<Button color={ctaText ? 'dark' : 'primary'} onClick={reload}>Buscar</Button>
								</InputGroup.Append>
								{ ctaText && (
									<Button className="ml-2 mb-1" color="primary" onClick={handleCtaClick}>{ctaText}</Button>
								)}
								{ onExport && (
									<Button className="ml-2 mb-1" color="primary" onClick={onExport}>Exportar</Button>
								)}
							</InputGroup>
							<div className="text-right mt-1 mb-0">
								{ secundaryCtaText && (
									<Button className="ml-2" color="dark" onClick={handleSecundaryCtaClick}>
										{secundaryCtaText}
									</Button>
								)}
								{ tertiaryCtaText && (
									<Button className="ml-2" color="dark" onClick={handleTertiaryCtaClick}>
										{tertiaryCtaText}
									</Button>
								)}
							</div>
						</div>
					)}
					{ title && <CardTitle>{title}</CardTitle> }
					{ subtitle && <CardSubtitle>{subtitle}</CardSubtitle> }
				</CardHeader>
			</Card>
		</React.Fragment>
	)
}